var _random = require('lodash.random');
var $ = require('jquery');


/**
 * MemorySequence Constructor
 * @param {Element} el SVG element/buttons container.
 */
var MemorySequence = function (el) {
  this.$container = $(el);
  this.$buttons = this.$container.find('.js-sequence-button');
};


/**
 * Removes styling and resets buttons.
 * @return {undefined}
 */
MemorySequence.prototype.cleanButtons = function() {
  var self = this;

  this.$buttons.each(function (button) {
    this.touched = false;
    var $this = $(this);
    var classes = $this.attr("class");
    var classArr = classes.split(" ");
    var cleanClassArr = classArr.filter(function (value) {
      return value != "keypad__button--win";
    });
    var cleanClasses = cleanClassArr.join(" ");

    $this
      .attr("class", cleanClasses)
      .css({
        "opacity" : ".25",
        "fill": "#FFF",
        "transition": "fill 0s"
      });
  });
};


/**
 * Creates a random memory sequence of length <length>.
 * @param  {Number} length Length of memory sequence.
 * @return {Array}        Sequence or length <length>.
 */
MemorySequence.prototype.newSequence = function(length) {

  var max = this.$buttons.length;
  length = length > max ? max : length;

  // Assign sequence to main object.
  this.sequence = (function () {
    var ret = [];
    var i = 0;
    var curr;

    while(i < length) {
      curr = _random(max - 1);
      if (ret.indexOf(curr) === -1) {
        ret.push(curr);
        i++;
      }
    }

    return ret;
  }());

  return this.sequence;

};


/**
 * Flashes hint for sequence.
 * @param  {Array} sequence OPTIONAL: Array of numbers for sequence.
 * @return {Promise}          Resolves when sequence hint finishes.
 */
MemorySequence.prototype.hintSequence = function(sequence) {
  var self = this;
  sequence = sequence || this.sequence;

  this.cleanButtons();

  return new Promise(function (resolve, reject) {
    if (!sequence) {
      reject();
    }

    var length = sequence.length - 1;
    var i = 0;

    var fade = function () {
      var callback = i === length ? resolve : fade;
      var curr = sequence[i];
      var $button = self.$buttons.eq(curr);

      i+=1;

      $button
        .fadeTo(450, 1, "swing", callback)
        .css({"fill": "#FFF428", "transition": "fill .45s"})
        .delay(150)
        .fadeTo(250, 0.25, "swing");
    };

    setTimeout(function () {
      fade();
    }, 150);

  });
};


/**
 * Handles touch/click events.
 * Resolves with SVG element on success.
 * Resovles with "challenge:fail" on fail.
 * @param  {Array} sequence Array of numbers for sequence that must be matched, in order.
 * @return {Promise}          Resolves on correct OR incorrect sequence.
 */
MemorySequence.prototype.listenForSequence = function(sequence) {
  var self = this;
  sequence = sequence || this.sequence;
  var i = 0;

  return new Promise(function (resolve, reject) {
    self.$buttons.on('touchstart click', function (e) {
      var _this = this;
      if(!_this.touched) {
        _this.touched = true;
        var $this = $(this);
        var oldClass = $this.attr('class');

        var match = self.$buttons.get(sequence[i]);

        if (Object.is(match, this)) {
          i+=1;
          $this.attr('class', oldClass + ' keypad__button--win');
        } else {
          self.$buttons.off('click');
          resolve("challenge:fail");
        }

        if (i === sequence.length) {
          self.$buttons.off('click');
          resolve(self.$container.get(0));
        }
      }
    });
  });
};

module.exports = MemorySequence;
